import client from '@/api/client'
import { type TimeOptionLabel } from '@/utils/time'
import { FocusAreaPayload } from '@/entities/frontlineManagerDash'

export const fetchResponseData = async (
    timeFilter: TimeOptionLabel,
    questionType: 'nps' | 'csat' | 'fivestar'
) => {
    return client.get(`/frontline-manager/responses`, {
        params: {
            timeUnit: timeFilter.time_unit,
            timeValue: timeFilter.time_value,
            questionType,
        },
    })
}

export const fetchRecommendedActions = async () => {
    return client.get(`/frontline-manager/recommended-actions`)
}

export const fetchDetractorActions = async (
    params: Partial<{
        timeUnit: string
        timeValue: number
        questionType: string
    }>
) => {
    return client.get(`/frontline-manager/detractor-actions`, { params })
}

export const sendPraise = async (
    slug: string,
    message: string,
    responseId: number,
    type: string,
    deliveryTypeData: any = {}
) => {
    return client.post(`/frontline-manager/praise/${slug}`, {
        message,
        responseId,
        type,
        deliveryTypeData,
    })
}

export const dismissAction = async (slug: string) => {
    return client.delete(`/frontline-manager/dismiss/${slug}`)
}

export const fetchScorecards = async (
    params: Partial<{
        timeUnit: string
        timeValue: number
        questionType: string
    }>
) => {
    return client.get('/frontline-manager/scorecards', { params })
}

export const saveFocusArea = async (focusAreaData: FocusAreaPayload) => {
    try {
        const apiResponse = await client.post(
            '/frontline-manager/focus-area',
            focusAreaData
        )
        return apiResponse.data
    } catch (error: any) {
        return error?.response?.data
    }
}

export const fetchLeaderboard = async (
    leaderboard: 'team' | 'location',
    timeFilter: TimeOptionLabel,
    questionType: 'nps' | 'csat' | 'fivestar'
) => {
    return client.get(`/frontline-manager/leaderboard/${leaderboard}`, {
        params: {
            timeUnit: timeFilter.time_unit,
            timeValue: timeFilter.time_value,
            questionType,
        },
    })
}

export const fetchCases = async (
    timeFilter: TimeOptionLabel,
    questionType: 'nps' | 'csat' | 'fivestar'
) => {
    return client.get('/frontline-manager/cases', {
        params: {
            timeUnit: timeFilter.time_unit,
            timeValue: timeFilter.time_value,
            questionType,
        },
    })
}

export const fetchFocusArea = async (
    timeFilter: TimeOptionLabel,
    questionType: 'nps' | 'csat' | 'fivestar'
) => {
    return client.get('/frontline-manager/focus-area', {
        params: {
            timeUnit: timeFilter.time_unit,
            timeValue: timeFilter.time_value,
            questionType,
        },
    })
}

export const storeDetractorAction = async (questionId: number) => {
    return client.post(
        `/frontline-manager/store-detractor-interaction/${questionId}`
    )
}

export const dismissDetractorAction = async (questionId: number) => {
    return client.delete(
        `/frontline-manager/store-detractor-interaction/${questionId}`
    )
}
